import { FormatType } from "../../Alert/Filter/FilterType";
import {
  ConfigurationFormType,
  ConfigurationPageTable,
  ConfigurationPageType,
  ConfigurationTableFilterType,
  RuleTypeType,
} from "../interfaces";

export const SETUP_BATCH_PAGE: ConfigurationPageTable = {
  type: ConfigurationPageType.TABLE,
  description: "CONF_DESC_SETUP_BATCH",
  count: 0,
  label: "BATCH",
  menuLabel: "BATCH",
  pageLabel: "BATCH_TITLE_SETUP",
  name: "batch",
  path: "batch",
  isStaff: true,
  hideInMenu: true,
  model: {
    entityName: "name",
    label: "BATCH_MODULE_PARAMETER",
    path: "/api/batch-module-parameters",
    name: "Batch Module Parameter",
    attributes: [
      {
        key: "name",
        order: 1,
        label: "BATCH_MODULE_NAME",
        visible: true,
      },
      {
        key: "is_active",
        order: 2,
        label: "BATCH_MODULE_ACTIVE",
        type: FormatType.BOOLEAN,
        visible: true,
        rules: [
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: {
              color: "error.main",
            },
          },
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
        ],
      },
      {
        key: "description",
        order: 3,
        label: "DESCRIPTION",
        visible: true,
        rules: [
          {
            column: "name",
            type: RuleTypeType.TRANSLATION,
          },
        ],
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
  },
  options: {
    formFields: [
      {
        key: "name",
        label: "NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "is_active",
        label: "BATCH_MODULE_ACTIVE",
        type: ConfigurationFormType.Check,
      },
    ],
    creatable: false,
    copyable: false,
    editable: true,
    editOptions: [
      {
        key: "name",
        flex: "100%",
        readonly: true,
      },
      {
        key: "is_active",
        flex: "100%",
      },
    ],
    deletable: false,
  },
};
